<div nz-row class="login-card">
  <div nz-col nzSpan="6" class="login-method" (click)="selectOption('google')">
    <img class="avatar-size" src="../../../../assets/img/google-avatar.png" />
    <span>{{ google }}</span>
  </div>
  <div nz-col nzSpan="6" class="login-method" (click)="selectOption('line')">
    <img class="avatar-size" src="../../../../assets/img/line-avatar.png" />
    <span>{{ line }}</span>
  </div>
    <div nz-col nzSpan="6" class="login-method" (click)="selectOption('apple')">
      <img class="avatar-size" src="../../../../assets/img/apple-avatar.png" />
      <span>{{ apple }}</span>
    </div>
  <div nz-col nzSpan="6" class="login-method" (click)="selectOption('usernamePassword')">
    <i nz-icon nzType="user"></i>
    <div>{{ usernamePassword }}</div>
  </div>
</div>
